export type PrincipalKind = 'User' | 'Group';

export function ownershipPrincipalKey(principalType: PrincipalKind, principalId: number): string {
    return `${principalType}:${principalId}`;
}

export function parseOwnershipPrincipalKey(key: string): { principalType: PrincipalKind; principalId: number } {
    const [principalType, idStr] = key.split(':');
    return {principalType: principalType as PrincipalKind, principalId: parseInt(idStr, 10)};
}
